import { CommonModule } from "@angular/common";
import { Component, input, output } from "@angular/core";
import { TicketDto } from "@malirang/api-client";
import { Badge, Icon } from "@malirang/front-share";

@Component({
    selector: "app-document-select-ticket-item",
    templateUrl: "./document-select-ticket-item.html",
    styleUrls: ["./document-select-ticket-item.css"],
    imports: [CommonModule, Badge, Icon],
})
export class DocumentSelectTicketItem {
    item = input.required<TicketDto>();
    active = input<boolean>(true);

    select = output<void>();
}
